import React from 'react';
import { startCase } from 'lodash';
import { Flex, Button, Text } from '@goodrx/matisse';
import { prettyAddress } from 'app/lib/utils';
import { useSynapse } from 'app/lib/synaptik';
import { Pharmacy } from 'app/types';

const PharmacyItem: React.FC<{ onClick: () => void; pharmacy: Pharmacy }> = ({ onClick, pharmacy }) => {
  const [consentedToHma] = useSynapse(({ user }) => [user.consentedToHma()]);
  const hasRetailPrice = !!pharmacy.drugPrice && !!pharmacy.retailPrice;

  return (
    <Flex
      onClick={onClick}
      justifyContent="space-between"
      alignItems="center"
      style={{ cursor: 'pointer' }}
      fontWeight={500}>
      <Flex flexDirection="column" flex={2}>
        <Text as="h4" my={1}>
          {startCase(pharmacy.name)}
        </Text>

        <Text
          as="p"
          color="greyDarker"
          m={0}
          style={{ whiteSpace: 'pre-line' }}
          dangerouslySetInnerHTML={{ __html: prettyAddress(pharmacy) }}
        />
      </Flex>

      <Flex flexDirection="column" alignItems="flex-end" flex={1}>
        {consentedToHma && (
          <Flex mb={2} fontSize={14}>
            {hasRetailPrice && (
              <Text color="greyDark" mr={2} style={{ textDecoration: 'line-through' }}>
                ${pharmacy.retailPrice?.toFixed(2)}
              </Text>
            )}

            {pharmacy.drugPrice ? (
              <Text color="secondary" fontWeight={600} textAlign="right">
                ${pharmacy.drugPrice.toFixed(2)}
              </Text>
            ) : (
              <Text color="greyDarkest" fontWeight={500} textAlign="right">
                No price found
              </Text>
            )}
          </Flex>
        )}

        <Button size="sm" variant="grey" ml={3} onClick={onClick}>
          Choose
        </Button>
      </Flex>
    </Flex>
  );
};

export default PharmacyItem;
